/*
 * THIS FILE WAS GENERATED BY "@atproto/lex". DO NOT EDIT.
 */

import { l } from '@atproto/lex'
import * as ActorDefs from './..\\actor\\defs.defs.js'
import * as GroupDefs from './..\\group\\defs.defs.js'
import * as EmbedRecord from './..\\..\\..\\app\\bsky\\embed\\record.defs.js'
import * as EmbedJoinLink from './..\\embed\\joinLink.defs.js'
import * as RichtextFacet from './..\\..\\..\\app\\bsky\\richtext\\facet.defs.js'

const $nsid = 'chat.bsky.convo.defs'

type $nsid = typeof $nsid

export { $nsid }

type ConvoRef = {
  $type?: 'chat.bsky.convo.defs#convoRef'
  did: l.DidString
  convoId: string
}

export type { ConvoRef }

const convoRef = /*#__PURE__*/ l.typedObject<ConvoRef>(
  $nsid,
  'convoRef',
  /*#__PURE__*/ l.object({
    did: /*#__PURE__*/ l.string({ format: 'did' }),
    convoId: /*#__PURE__*/ l.string(),
  }),
)

export { convoRef }

/** A reference to another message within the same convo, used to indicate that a message is a reply to it. */
type ReplyRef = { $type?: 'chat.bsky.convo.defs#replyRef'; messageId: string }

export type { ReplyRef }

/** A reference to another message within the same convo, used to indicate that a message is a reply to it. */
const replyRef = /*#__PURE__*/ l.typedObject<ReplyRef>(
  $nsid,
  'replyRef',
  /*#__PURE__*/ l.object({ messageId: /*#__PURE__*/ l.string() }),
)

export { replyRef }

type ConvoKind = 'direct' | 'group' | l.UnknownString

export type { ConvoKind }

const convoKind = /*#__PURE__*/ l.string<{ knownValues: ['direct', 'group'] }>()

export { convoKind }

type ConvoView = {
  $type?: 'chat.bsky.convo.defs#convoView'
  id: string
  rev: string

  /**
   * Union field that has data specific to different kinds of convos.
   */
  kind?: l.$Typed<DirectConvo> | l.$Typed<GroupConvo> | l.Unknown$TypedObject
  muted: boolean

  /**
   * Convo status for the viewer member (not the convo itself).
   */
  status?: ConvoStatus

  /**
   * Members of this conversation. For direct convos, it will be an immutable list of the 2 members. For group convos, it will a list of important members (the first few members, the viewer, the member who added the viewer, the member who sent the last message, the member who sent the last reaction), but will not contain the full list of members. Use chat.bsky.convo.getConvoMembers to list all members.
   */
  members: ActorDefs.ProfileViewBasic[]
  lastMessage?:
    | l.$Typed<MessageView>
    | l.$Typed<DeletedMessageView>
    | l.$Typed<SystemMessageView>
    | l.Unknown$TypedObject
  unreadCount: number
  lastReaction?: l.$Typed<MessageAndReactionView> | l.Unknown$TypedObject
}

export type { ConvoView }

const convoView = /*#__PURE__*/ l.typedObject<ConvoView>(
  $nsid,
  'convoView',
  /*#__PURE__*/ l.object({
    id: /*#__PURE__*/ l.string(),
    rev: /*#__PURE__*/ l.string(),
    kind: /*#__PURE__*/ l.optional(
      /*#__PURE__*/ l.typedUnion(
        [
          /*#__PURE__*/ l.typedRef<DirectConvo>((() => directConvo) as any),
          /*#__PURE__*/ l.typedRef<GroupConvo>((() => groupConvo) as any),
        ],
        false,
      ),
    ),
    muted: /*#__PURE__*/ l.boolean(),
    status: /*#__PURE__*/ l.optional(
      /*#__PURE__*/ l.ref<ConvoStatus>((() => convoStatus) as any),
    ),
    members: /*#__PURE__*/ l.array(
      /*#__PURE__*/ l.ref<ActorDefs.ProfileViewBasic>(
        (() => ActorDefs.profileViewBasic) as any,
      ),
    ),
    lastMessage: /*#__PURE__*/ l.optional(
      /*#__PURE__*/ l.typedUnion(
        [
          /*#__PURE__*/ l.typedRef<MessageView>((() => messageView) as any),
          /*#__PURE__*/ l.typedRef<DeletedMessageView>(
            (() => deletedMessageView) as any,
          ),
          /*#__PURE__*/ l.typedRef<SystemMessageView>(
            (() => systemMessageView) as any,
          ),
        ],
        false,
      ),
    ),
    unreadCount: /*#__PURE__*/ l.integer(),
    lastReaction: /*#__PURE__*/ l.optional(
      /*#__PURE__*/ l.typedUnion(
        [
          /*#__PURE__*/ l.typedRef<MessageAndReactionView>(
            (() => messageAndReactionView) as any,
          ),
        ],
        false,
      ),
    ),
  }),
)

export { convoView }

type GroupConvo = {
  $type?: 'chat.bsky.convo.defs#groupConvo'

  /**
   * The display name of the group conversation.
   */
  name: string
  joinLink?: GroupDefs.JoinLinkView
  createdAt: l.DatetimeString

  /**
   * The lock status of the conversation.
   */
  lockStatus: ConvoLockStatus

  /**
   * The total number of members in the group conversation.
   */
  memberCount: number

  /**
   * The maximum number of members allowed in the group conversation.
   */
  memberLimit: number

  /**
   * The total number of pending join requests for the group conversation. Only present for the owner. Capped at 21.
   */
  joinRequestCount?: number

  /**
   * The number of unread join requests for the group conversation. Only present for the owner.
   */
  unreadJoinRequestCount?: number

  /**
   * Whether the lock status is being forced by a moderation override (account inactivation or convo takedown) rather than the owner's own setting.
   */
  lockStatusModerationOverride: boolean
}

export type { GroupConvo }

const groupConvo = /*#__PURE__*/ l.typedObject<GroupConvo>(
  $nsid,
  'groupConvo',
  /*#__PURE__*/ l.object({
    name: /*#__PURE__*/ l.string({ maxLength: 500, maxGraphemes: 50 }),
    joinLink: /*#__PURE__*/ l.optional(
      /*#__PURE__*/ l.ref<GroupDefs.JoinLinkView>(
        (() => GroupDefs.joinLinkView) as any,
      ),
    ),
    createdAt: /*#__PURE__*/ l.string({ format: 'datetime' }),
    lockStatus: /*#__PURE__*/ l.ref<ConvoLockStatus>(
      (() => convoLockStatus) as any,
    ),
    memberCount: /*#__PURE__*/ l.integer(),
    memberLimit: /*#__PURE__*/ l.integer(),
    joinRequestCount: /*#__PURE__*/ l.optional(/*#__PURE__*/ l.integer()),
    unreadJoinRequestCount: /*#__PURE__*/ l.optional(/*#__PURE__*/ l.integer()),
    lockStatusModerationOverride: /*#__PURE__*/ l.boolean(),
  }),
)

export { groupConvo }

type MessageRef = {
  $type?: 'chat.bsky.convo.defs#messageRef'
  did: l.DidString
  convoId: string
  messageId: string
}

export type { MessageRef }

const messageRef = /*#__PURE__*/ l.typedObject<MessageRef>(
  $nsid,
  'messageRef',
  /*#__PURE__*/ l.object({
    did: /*#__PURE__*/ l.string({ format: 'did' }),
    convoId: /*#__PURE__*/ l.string(),
    messageId: /*#__PURE__*/ l.string(),
  }),
)

export { messageRef }

type ConvoStatus = 'request' | 'accepted' | l.UnknownString

export type { ConvoStatus }

const convoStatus = /*#__PURE__*/ l.string<{
  knownValues: ['request', 'accepted']
}>()

export { convoStatus }

type DirectConvo = { $type?: 'chat.bsky.convo.defs#directConvo' }

export type { DirectConvo }

const directConvo = /*#__PURE__*/ l.typedObject<DirectConvo>(
  $nsid,
  'directConvo',
  /*#__PURE__*/ l.object({}),
)

export { directConvo }

type MessageView = {
  $type?: 'chat.bsky.convo.defs#messageView'
  id: string
  rev: string
  text: string
  embed?:
    | l.$Typed<EmbedRecord.View>
    | l.$Typed<EmbedJoinLink.View>
    | l.Unknown$TypedObject

  /**
   * Annotations of text (mentions, URLs, hashtags, etc)
   */
  facets?: RichtextFacet.Main[]
  sender: MessageViewSender
  sentAt: l.DatetimeString

  /**
   * If set, the message this message is replying to. The full view of the referenced message is embedded so the client can render it inline. Only a single level is embedded: the embedded message will not itself have a populated 'replyTo' field even if it was also a reply.
   */
  replyTo?:
    | l.$Typed<MessageView>
    | l.$Typed<DeletedMessageView>
    | l.$Typed<MessageBeforeUserJoinedGroupView>
    | l.Unknown$TypedObject

  /**
   * Reactions to this message, in ascending order of creation time.
   */
  reactions?: ReactionView[]
}

export type { MessageView }

const messageView = /*#__PURE__*/ l.typedObject<MessageView>(
  $nsid,
  'messageView',
  /*#__PURE__*/ l.object({
    id: /*#__PURE__*/ l.string(),
    rev: /*#__PURE__*/ l.string(),
    text: /*#__PURE__*/ l.string({ maxLength: 10000, maxGraphemes: 1000 }),
    embed: /*#__PURE__*/ l.optional(
      /*#__PURE__*/ l.typedUnion(
        [
          /*#__PURE__*/ l.typedRef<EmbedRecord.View>(
            (() => EmbedRecord.view) as any,
          ),
          /*#__PURE__*/ l.typedRef<EmbedJoinLink.View>(
            (() => EmbedJoinLink.view) as any,
          ),
        ],
        false,
      ),
    ),
    facets: /*#__PURE__*/ l.optional(
      /*#__PURE__*/ l.array(
        /*#__PURE__*/ l.ref<RichtextFacet.Main>(
          (() => RichtextFacet.main) as any,
        ),
      ),
    ),
    sender: /*#__PURE__*/ l.ref<MessageViewSender>(
      (() => messageViewSender) as any,
    ),
    sentAt: /*#__PURE__*/ l.string({ format: 'datetime' }),
    replyTo: /*#__PURE__*/ l.optional(
      /*#__PURE__*/ l.typedUnion(
        [
          /*#__PURE__*/ l.typedRef<MessageView>((() => messageView) as any),
          /*#__PURE__*/ l.typedRef<DeletedMessageView>(
            (() => deletedMessageView) as any,
          ),
          /*#__PURE__*/ l.typedRef<MessageBeforeUserJoinedGroupView>(
            (() => messageBeforeUserJoinedGroupView) as any,
          ),
        ],
        false,
      ),
    ),
    reactions: /*#__PURE__*/ l.optional(
      /*#__PURE__*/ l.array(
        /*#__PURE__*/ l.ref<ReactionView>((() => reactionView) as any),
      ),
    ),
  }),
)

export { messageView }

/** Event indicating a member was added to a group convo. The member who was added gets a logBeginConvo (to create the convo) but also a logAddMember (to show the system message as the first message the user sees). */
type LogAddMember = {
  $type?: 'chat.bsky.convo.defs#logAddMember'
  rev: string
  convoId: string

  /**
   * A system message with data of type #systemMessageDataAddMember
   */
  message: SystemMessageView

  /**
   * Profiles referred in the system message.
   */
  relatedProfiles: ActorDefs.ProfileViewBasic[]
}

export type { LogAddMember }

/** Event indicating a member was added to a group convo. The member who was added gets a logBeginConvo (to create the convo) but also a logAddMember (to show the system message as the first message the user sees). */
const logAddMember = /*#__PURE__*/ l.typedObject<LogAddMember>(
  $nsid,
  'logAddMember',
  /*#__PURE__*/ l.object({
    rev: /*#__PURE__*/ l.string(),
    convoId: /*#__PURE__*/ l.string(),
    message: /*#__PURE__*/ l.ref<SystemMessageView>(
      (() => systemMessageView) as any,
    ),
    relatedProfiles: /*#__PURE__*/ l.array(
      /*#__PURE__*/ l.ref<ActorDefs.ProfileViewBasic>(
        (() => ActorDefs.profileViewBasic) as any,
      ),
    ),
  }),
)

export { logAddMember }

/** Event indicating info about group convo was edited. */
type LogEditGroup = {
  $type?: 'chat.bsky.convo.defs#logEditGroup'
  rev: string
  convoId: string

  /**
   * A system message with data of type #systemMessageDataEditGroup
   */
  message: SystemMessageView
}

export type { LogEditGroup }

/** Event indicating info about group convo was edited. */
const logEditGroup = /*#__PURE__*/ l.typedObject<LogEditGroup>(
  $nsid,
  'logEditGroup',
  /*#__PURE__*/ l.object({
    rev: /*#__PURE__*/ l.string(),
    convoId: /*#__PURE__*/ l.string(),
    message: /*#__PURE__*/ l.ref<SystemMessageView>(
      (() => systemMessageView) as any,
    ),
  }),
)

export { logEditGroup }

/** Event indicating a group convo was locked. */
type LogLockConvo = {
  $type?: 'chat.bsky.convo.defs#logLockConvo'
  rev: string
  convoId: string

  /**
   * A system message with data of type #systemMessageDataLockConvo
   */
  message: SystemMessageView

  /**
   * Profiles referred in the system message.
   */
  relatedProfiles: ActorDefs.ProfileViewBasic[]
}

export type { LogLockConvo }

/** Event indicating a group convo was locked. */
const logLockConvo = /*#__PURE__*/ l.typedObject<LogLockConvo>(
  $nsid,
  'logLockConvo',
  /*#__PURE__*/ l.object({
    rev: /*#__PURE__*/ l.string(),
    convoId: /*#__PURE__*/ l.string(),
    message: /*#__PURE__*/ l.ref<SystemMessageView>(
      (() => systemMessageView) as any,
    ),
    relatedProfiles: /*#__PURE__*/ l.array(
      /*#__PURE__*/ l.ref<ActorDefs.ProfileViewBasic>(
        (() => ActorDefs.profileViewBasic) as any,
      ),
    ),
  }),
)

export { logLockConvo }

/** Event indicating the viewer muted a convo. Can be direct or group. */
type LogMuteConvo = {
  $type?: 'chat.bsky.convo.defs#logMuteConvo'
  rev: string
  convoId: string
}

export type { LogMuteConvo }

/** Event indicating the viewer muted a convo. Can be direct or group. */
const logMuteConvo = /*#__PURE__*/ l.typedObject<LogMuteConvo>(
  $nsid,
  'logMuteConvo',
  /*#__PURE__*/ l.object({
    rev: /*#__PURE__*/ l.string(),
    convoId: /*#__PURE__*/ l.string(),
  }),
)

export { logMuteConvo }

/** Event indicating a convo was read up to a certain message. */
type LogReadConvo = {
  $type?: 'chat.bsky.convo.defs#logReadConvo'
  rev: string
  convoId: string
  message:
    | l.$Typed<MessageView>
    | l.$Typed<DeletedMessageView>
    | l.$Typed<SystemMessageView>
    | l.Unknown$TypedObject
}

export type { LogReadConvo }

/** Event indicating a convo was read up to a certain message. */
const logReadConvo = /*#__PURE__*/ l.typedObject<LogReadConvo>(
  $nsid,
  'logReadConvo',
  /*#__PURE__*/ l.object({
    rev: /*#__PURE__*/ l.string(),
    convoId: /*#__PURE__*/ l.string(),
    message: /*#__PURE__*/ l.typedUnion(
      [
        /*#__PURE__*/ l.typedRef<MessageView>((() => messageView) as any),
        /*#__PURE__*/ l.typedRef<DeletedMessageView>(
          (() => deletedMessageView) as any,
        ),
        /*#__PURE__*/ l.typedRef<SystemMessageView>(
          (() => systemMessageView) as any,
        ),
      ],
      false,
    ),
  }),
)

export { logReadConvo }

type MessageInput = {
  $type?: 'chat.bsky.convo.defs#messageInput'
  text: string
  embed?:
    | l.$Typed<EmbedRecord.Main>
    | l.$Typed<EmbedJoinLink.Main>
    | l.Unknown$TypedObject

  /**
   * Annotations of text (mentions, URLs, hashtags, etc)
   */
  facets?: RichtextFacet.Main[]

  /**
   * If set, the message this message is replying to. The referenced message must be in the same convo.
   */
  replyTo?: ReplyRef
}

export type { MessageInput }

const messageInput = /*#__PURE__*/ l.typedObject<MessageInput>(
  $nsid,
  'messageInput',
  /*#__PURE__*/ l.object({
    text: /*#__PURE__*/ l.string({ maxLength: 10000, maxGraphemes: 1000 }),
    embed: /*#__PURE__*/ l.optional(
      /*#__PURE__*/ l.typedUnion(
        [
          /*#__PURE__*/ l.typedRef<EmbedRecord.Main>(
            (() => EmbedRecord.main) as any,
          ),
          /*#__PURE__*/ l.typedRef<EmbedJoinLink.Main>(
            (() => EmbedJoinLink.main) as any,
          ),
        ],
        false,
      ),
    ),
    facets: /*#__PURE__*/ l.optional(
      /*#__PURE__*/ l.array(
        /*#__PURE__*/ l.ref<RichtextFacet.Main>(
          (() => RichtextFacet.main) as any,
        ),
      ),
    ),
    replyTo: /*#__PURE__*/ l.optional(
      /*#__PURE__*/ l.ref<ReplyRef>((() => replyRef) as any),
    ),
  }),
)

export { messageInput }

type ReactionView = {
  $type?: 'chat.bsky.convo.defs#reactionView'
  value: string
  sender: ReactionViewSender
  createdAt: l.DatetimeString
}

export type { ReactionView }

const reactionView = /*#__PURE__*/ l.typedObject<ReactionView>(
  $nsid,
  'reactionView',
  /*#__PURE__*/ l.object({
    value: /*#__PURE__*/ l.string(),
    sender: /*#__PURE__*/ l.ref<ReactionViewSender>(
      (() => reactionViewSender) as any,
    ),
    createdAt: /*#__PURE__*/ l.string({ format: 'datetime' }),
  }),
)

export { reactionView }

/** Event indicating a convo containing the viewer was started. Can be direct or group. When a member is added to a group convo, they also get this event. */
type LogBeginConvo = {
  $type?: 'chat.bsky.convo.defs#logBeginConvo'
  rev: string
  convoId: string
}

export type { LogBeginConvo }

/** Event indicating a convo containing the viewer was started. Can be direct or group. When a member is added to a group convo, they also get this event. */
const logBeginConvo = /*#__PURE__*/ l.typedObject<LogBeginConvo>(
  $nsid,
  'logBeginConvo',
  /*#__PURE__*/ l.object({
    rev: /*#__PURE__*/ l.string(),
    convoId: /*#__PURE__*/ l.string(),
  }),
)

export { logBeginConvo }

/** Event indicating the viewer left a convo. Can be direct or group. */
type LogLeaveConvo = {
  $type?: 'chat.bsky.convo.defs#logLeaveConvo'
  rev: string
  convoId: string
}

export type { LogLeaveConvo }

/** Event indicating the viewer left a convo. Can be direct or group. */
const logLeaveConvo = /*#__PURE__*/ l.typedObject<LogLeaveConvo>(
  $nsid,
  'logLeaveConvo',
  /*#__PURE__*/ l.object({
    rev: /*#__PURE__*/ l.string(),
    convoId: /*#__PURE__*/ l.string(),
  }),
)

export { logLeaveConvo }

/** Event indicating a member joined a group convo via join link. The member who was added gets a logBeginConvo (to create the convo) but also a logMemberJoin (to show the system message as the first message the user sees). */
type LogMemberJoin = {
  $type?: 'chat.bsky.convo.defs#logMemberJoin'
  rev: string
  convoId: string

  /**
   * A system message with data of type #systemMessageDataMemberJoin
   */
  message: SystemMessageView

  /**
   * Profiles referred in the system message.
   */
  relatedProfiles: ActorDefs.ProfileViewBasic[]
}

export type { LogMemberJoin }

/** Event indicating a member joined a group convo via join link. The member who was added gets a logBeginConvo (to create the convo) but also a logMemberJoin (to show the system message as the first message the user sees). */
const logMemberJoin = /*#__PURE__*/ l.typedObject<LogMemberJoin>(
  $nsid,
  'logMemberJoin',
  /*#__PURE__*/ l.object({
    rev: /*#__PURE__*/ l.string(),
    convoId: /*#__PURE__*/ l.string(),
    message: /*#__PURE__*/ l.ref<SystemMessageView>(
      (() => systemMessageView) as any,
    ),
    relatedProfiles: /*#__PURE__*/ l.array(
      /*#__PURE__*/ l.ref<ActorDefs.ProfileViewBasic>(
        (() => ActorDefs.profileViewBasic) as any,
      ),
    ),
  }),
)

export { logMemberJoin }

/** Event indicating the viewer accepted a convo, and it can be moved out of the request inbox. Can be direct or group. */
type LogAcceptConvo = {
  $type?: 'chat.bsky.convo.defs#logAcceptConvo'
  rev: string
  convoId: string
}

export type { LogAcceptConvo }

/** Event indicating the viewer accepted a convo, and it can be moved out of the request inbox. Can be direct or group. */
const logAcceptConvo = /*#__PURE__*/ l.typedObject<LogAcceptConvo>(
  $nsid,
  'logAcceptConvo',
  /*#__PURE__*/ l.object({
    rev: /*#__PURE__*/ l.string(),
    convoId: /*#__PURE__*/ l.string(),
  }),
)

export { logAcceptConvo }

/** Event indicating a reaction was added to a message. */
type LogAddReaction = {
  $type?: 'chat.bsky.convo.defs#logAddReaction'
  rev: string
  convoId: string
  message:
    l.$Typed<MessageView> | l.$Typed<DeletedMessageView> | l.Unknown$TypedObject
  reaction: ReactionView

  /**
   * Profiles referred in the message and reaction views. This isn't required for compatibility, because it was added later, but should generally be present.
   */
  relatedProfiles?: ActorDefs.ProfileViewBasic[]
}

export type { LogAddReaction }

/** Event indicating a reaction was added to a message. */
const logAddReaction = /*#__PURE__*/ l.typedObject<LogAddReaction>(
  $nsid,
  'logAddReaction',
  /*#__PURE__*/ l.object({
    rev: /*#__PURE__*/ l.string(),
    convoId: /*#__PURE__*/ l.string(),
    message: /*#__PURE__*/ l.typedUnion(
      [
        /*#__PURE__*/ l.typedRef<MessageView>((() => messageView) as any),
        /*#__PURE__*/ l.typedRef<DeletedMessageView>(
          (() => deletedMessageView) as any,
        ),
      ],
      false,
    ),
    reaction: /*#__PURE__*/ l.ref<ReactionView>((() => reactionView) as any),
    relatedProfiles: /*#__PURE__*/ l.optional(
      /*#__PURE__*/ l.array(
        /*#__PURE__*/ l.ref<ActorDefs.ProfileViewBasic>(
          (() => ActorDefs.profileViewBasic) as any,
        ),
      ),
    ),
  }),
)

export { logAddReaction }

/** Event indicating a member voluntarily left a group convo. The member who was removed gets a logLeaveConvo (to leave the convo) but not a logMemberLeave (because they already left, so can't see the system message). */
type LogMemberLeave = {
  $type?: 'chat.bsky.convo.defs#logMemberLeave'
  rev: string
  convoId: string

  /**
   * A system message with data of type #systemMessageDataMemberLeave
   */
  message: SystemMessageView

  /**
   * Profiles referred in the system message.
   */
  relatedProfiles: ActorDefs.ProfileViewBasic[]
}

export type { LogMemberLeave }

/** Event indicating a member voluntarily left a group convo. The member who was removed gets a logLeaveConvo (to leave the convo) but not a logMemberLeave (because they already left, so can't see the system message). */
const logMemberLeave = /*#__PURE__*/ l.typedObject<LogMemberLeave>(
  $nsid,
  'logMemberLeave',
  /*#__PURE__*/ l.object({
    rev: /*#__PURE__*/ l.string(),
    convoId: /*#__PURE__*/ l.string(),
    message: /*#__PURE__*/ l.ref<SystemMessageView>(
      (() => systemMessageView) as any,
    ),
    relatedProfiles: /*#__PURE__*/ l.array(
      /*#__PURE__*/ l.ref<ActorDefs.ProfileViewBasic>(
        (() => ActorDefs.profileViewBasic) as any,
      ),
    ),
  }),
)

export { logMemberLeave }

/** @deprecated use logReadConvo instead. Event indicating a convo was read up to a certain message. */
type LogReadMessage = {
  $type?: 'chat.bsky.convo.defs#logReadMessage'
  rev: string
  convoId: string
  message:
    | l.$Typed<MessageView>
    | l.$Typed<DeletedMessageView>
    | l.$Typed<SystemMessageView>
    | l.Unknown$TypedObject
}

export type { LogReadMessage }

/** @deprecated use logReadConvo instead. Event indicating a convo was read up to a certain message. */
const logReadMessage = /*#__PURE__*/ l.typedObject<LogReadMessage>(
  $nsid,
  'logReadMessage',
  /*#__PURE__*/ l.object({
    rev: /*#__PURE__*/ l.string(),
    convoId: /*#__PURE__*/ l.string(),
    message: /*#__PURE__*/ l.typedUnion(
      [
        /*#__PURE__*/ l.typedRef<MessageView>((() => messageView) as any),
        /*#__PURE__*/ l.typedRef<DeletedMessageView>(
          (() => deletedMessageView) as any,
        ),
        /*#__PURE__*/ l.typedRef<SystemMessageView>(
          (() => systemMessageView) as any,
        ),
      ],
      false,
    ),
  }),
)

export { logReadMessage }

/** Event indicating a group convo was unlocked. */
type LogUnlockConvo = {
  $type?: 'chat.bsky.convo.defs#logUnlockConvo'
  rev: string
  convoId: string

  /**
   * A system message with data of type #systemMessageDataUnlockConvo
   */
  message: SystemMessageView

  /**
   * Profiles referred in the system message.
   */
  relatedProfiles: ActorDefs.ProfileViewBasic[]
}

export type { LogUnlockConvo }

/** Event indicating a group convo was unlocked. */
const logUnlockConvo = /*#__PURE__*/ l.typedObject<LogUnlockConvo>(
  $nsid,
  'logUnlockConvo',
  /*#__PURE__*/ l.object({
    rev: /*#__PURE__*/ l.string(),
    convoId: /*#__PURE__*/ l.string(),
    message: /*#__PURE__*/ l.ref<SystemMessageView>(
      (() => systemMessageView) as any,
    ),
    relatedProfiles: /*#__PURE__*/ l.array(
      /*#__PURE__*/ l.ref<ActorDefs.ProfileViewBasic>(
        (() => ActorDefs.profileViewBasic) as any,
      ),
    ),
  }),
)

export { logUnlockConvo }

/** Event indicating the viewer unmuted a convo. Can be direct or group. */
type LogUnmuteConvo = {
  $type?: 'chat.bsky.convo.defs#logUnmuteConvo'
  rev: string
  convoId: string
}

export type { LogUnmuteConvo }

/** Event indicating the viewer unmuted a convo. Can be direct or group. */
const logUnmuteConvo = /*#__PURE__*/ l.typedObject<LogUnmuteConvo>(
  $nsid,
  'logUnmuteConvo',
  /*#__PURE__*/ l.object({
    rev: /*#__PURE__*/ l.string(),
    convoId: /*#__PURE__*/ l.string(),
  }),
)

export { logUnmuteConvo }

type ConvoLockStatus =
  'unlocked' | 'locked' | 'locked-permanently' | l.UnknownString

export type { ConvoLockStatus }

const convoLockStatus = /*#__PURE__*/ l.string<{
  knownValues: ['unlocked', 'locked', 'locked-permanently']
}>()

export { convoLockStatus }

/** Event indicating a settings about a join link for a group convo were edited. */
type LogEditJoinLink = {
  $type?: 'chat.bsky.convo.defs#logEditJoinLink'
  rev: string
  convoId: string

  /**
   * A system message with data of type #systemMessageDataEditJoinLink
   */
  message: SystemMessageView
}

export type { LogEditJoinLink }

/** Event indicating a settings about a join link for a group convo were edited. */
const logEditJoinLink = /*#__PURE__*/ l.typedObject<LogEditJoinLink>(
  $nsid,
  'logEditJoinLink',
  /*#__PURE__*/ l.object({
    rev: /*#__PURE__*/ l.string(),
    convoId: /*#__PURE__*/ l.string(),
    message: /*#__PURE__*/ l.ref<SystemMessageView>(
      (() => systemMessageView) as any,
    ),
  }),
)

export { logEditJoinLink }

/** Event indicating a member was removed from a group convo. The member who was removed gets a logLeaveConvo (to leave the convo) but not a logRemoveMember (because they already left, so can't see the system message). */
type LogRemoveMember = {
  $type?: 'chat.bsky.convo.defs#logRemoveMember'
  rev: string
  convoId: string

  /**
   * A system message with data of type #systemMessageDataRemoveMember
   */
  message: SystemMessageView

  /**
   * Profiles referred in the system message.
   */
  relatedProfiles: ActorDefs.ProfileViewBasic[]
}

export type { LogRemoveMember }

/** Event indicating a member was removed from a group convo. The member who was removed gets a logLeaveConvo (to leave the convo) but not a logRemoveMember (because they already left, so can't see the system message). */
const logRemoveMember = /*#__PURE__*/ l.typedObject<LogRemoveMember>(
  $nsid,
  'logRemoveMember',
  /*#__PURE__*/ l.object({
    rev: /*#__PURE__*/ l.string(),
    convoId: /*#__PURE__*/ l.string(),
    message: /*#__PURE__*/ l.ref<SystemMessageView>(
      (() => systemMessageView) as any,
    ),
    relatedProfiles: /*#__PURE__*/ l.array(
      /*#__PURE__*/ l.ref<ActorDefs.ProfileViewBasic>(
        (() => ActorDefs.profileViewBasic) as any,
      ),
    ),
  }),
)

export { logRemoveMember }

/** Event indicating a user-originated message was created. Is not emitted for system messages. */
type LogCreateMessage = {
  $type?: 'chat.bsky.convo.defs#logCreateMessage'
  rev: string
  convoId: string
  message:
    l.$Typed<MessageView> | l.$Typed<DeletedMessageView> | l.Unknown$TypedObject

  /**
   * Profiles referred to in the message view. This isn't required for compatibility, because it was added later, but should generally be present.
   */
  relatedProfiles?: ActorDefs.ProfileViewBasic[]
}

export type { LogCreateMessage }

/** Event indicating a user-originated message was created. Is not emitted for system messages. */
const logCreateMessage = /*#__PURE__*/ l.typedObject<LogCreateMessage>(
  $nsid,
  'logCreateMessage',
  /*#__PURE__*/ l.object({
    rev: /*#__PURE__*/ l.string(),
    convoId: /*#__PURE__*/ l.string(),
    message: /*#__PURE__*/ l.typedUnion(
      [
        /*#__PURE__*/ l.typedRef<MessageView>((() => messageView) as any),
        /*#__PURE__*/ l.typedRef<DeletedMessageView>(
          (() => deletedMessageView) as any,
        ),
      ],
      false,
    ),
    relatedProfiles: /*#__PURE__*/ l.optional(
      /*#__PURE__*/ l.array(
        /*#__PURE__*/ l.ref<ActorDefs.ProfileViewBasic>(
          (() => ActorDefs.profileViewBasic) as any,
        ),
      ),
    ),
  }),
)

export { logCreateMessage }

/** Event indicating a user-originated message was deleted. Is not emitted for system messages. */
type LogDeleteMessage = {
  $type?: 'chat.bsky.convo.defs#logDeleteMessage'
  rev: string
  convoId: string
  message:
    l.$Typed<MessageView> | l.$Typed<DeletedMessageView> | l.Unknown$TypedObject
}

export type { LogDeleteMessage }

/** Event indicating a user-originated message was deleted. Is not emitted for system messages. */
const logDeleteMessage = /*#__PURE__*/ l.typedObject<LogDeleteMessage>(
  $nsid,
  'logDeleteMessage',
  /*#__PURE__*/ l.object({
    rev: /*#__PURE__*/ l.string(),
    convoId: /*#__PURE__*/ l.string(),
    message: /*#__PURE__*/ l.typedUnion(
      [
        /*#__PURE__*/ l.typedRef<MessageView>((() => messageView) as any),
        /*#__PURE__*/ l.typedRef<DeletedMessageView>(
          (() => deletedMessageView) as any,
        ),
      ],
      false,
    ),
  }),
)

export { logDeleteMessage }

/** Event indicating a join link was created for a group convo. */
type LogCreateJoinLink = {
  $type?: 'chat.bsky.convo.defs#logCreateJoinLink'
  rev: string
  convoId: string

  /**
   * A system message with data of type #systemMessageDataCreateJoinLink
   */
  message: SystemMessageView
}

export type { LogCreateJoinLink }

/** Event indicating a join link was created for a group convo. */
const logCreateJoinLink = /*#__PURE__*/ l.typedObject<LogCreateJoinLink>(
  $nsid,
  'logCreateJoinLink',
  /*#__PURE__*/ l.object({
    rev: /*#__PURE__*/ l.string(),
    convoId: /*#__PURE__*/ l.string(),
    message: /*#__PURE__*/ l.ref<SystemMessageView>(
      (() => systemMessageView) as any,
    ),
  }),
)

export { logCreateJoinLink }

/** Event indicating a join link was enabled for a group convo. */
type LogEnableJoinLink = {
  $type?: 'chat.bsky.convo.defs#logEnableJoinLink'
  rev: string
  convoId: string

  /**
   * A system message with data of type #systemMessageDataEnableJoinLink
   */
  message: SystemMessageView
}

export type { LogEnableJoinLink }

/** Event indicating a join link was enabled for a group convo. */
const logEnableJoinLink = /*#__PURE__*/ l.typedObject<LogEnableJoinLink>(
  $nsid,
  'logEnableJoinLink',
  /*#__PURE__*/ l.object({
    rev: /*#__PURE__*/ l.string(),
    convoId: /*#__PURE__*/ l.string(),
    message: /*#__PURE__*/ l.ref<SystemMessageView>(
      (() => systemMessageView) as any,
    ),
  }),
)

export { logEnableJoinLink }

/** Event indicating a reaction was removed from a message. */
type LogRemoveReaction = {
  $type?: 'chat.bsky.convo.defs#logRemoveReaction'
  rev: string
  convoId: string
  message:
    l.$Typed<MessageView> | l.$Typed<DeletedMessageView> | l.Unknown$TypedObject
  reaction: ReactionView

  /**
   * Profiles referred in the message and reaction views. This isn't required for compatibility, because it was added later, but should generally be present.
   */
  relatedProfiles?: ActorDefs.ProfileViewBasic[]
}

export type { LogRemoveReaction }

/** Event indicating a reaction was removed from a message. */
const logRemoveReaction = /*#__PURE__*/ l.typedObject<LogRemoveReaction>(
  $nsid,
  'logRemoveReaction',
  /*#__PURE__*/ l.object({
    rev: /*#__PURE__*/ l.string(),
    convoId: /*#__PURE__*/ l.string(),
    message: /*#__PURE__*/ l.typedUnion(
      [
        /*#__PURE__*/ l.typedRef<MessageView>((() => messageView) as any),
        /*#__PURE__*/ l.typedRef<DeletedMessageView>(
          (() => deletedMessageView) as any,
        ),
      ],
      false,
    ),
    reaction: /*#__PURE__*/ l.ref<ReactionView>((() => reactionView) as any),
    relatedProfiles: /*#__PURE__*/ l.optional(
      /*#__PURE__*/ l.array(
        /*#__PURE__*/ l.ref<ActorDefs.ProfileViewBasic>(
          (() => ActorDefs.profileViewBasic) as any,
        ),
      ),
    ),
  }),
)

export { logRemoveReaction }

type MessageViewSender = {
  $type?: 'chat.bsky.convo.defs#messageViewSender'
  did: l.DidString
}

export type { MessageViewSender }

const messageViewSender = /*#__PURE__*/ l.typedObject<MessageViewSender>(
  $nsid,
  'messageViewSender',
  /*#__PURE__*/ l.object({ did: /*#__PURE__*/ l.string({ format: 'did' }) }),
)

export { messageViewSender }

type SystemMessageView = {
  $type?: 'chat.bsky.convo.defs#systemMessageView'
  id: string
  rev: string
  data:
    | l.$Typed<SystemMessageDataAddMember>
    | l.$Typed<SystemMessageDataRemoveMember>
    | l.$Typed<SystemMessageDataMemberJoin>
    | l.$Typed<SystemMessageDataMemberLeave>
    | l.$Typed<SystemMessageDataLockConvo>
    | l.$Typed<SystemMessageDataUnlockConvo>
    | l.$Typed<SystemMessageDataLockConvoPermanently>
    | l.$Typed<SystemMessageDataEditGroup>
    | l.$Typed<SystemMessageDataCreateJoinLink>
    | l.$Typed<SystemMessageDataEditJoinLink>
    | l.$Typed<SystemMessageDataEnableJoinLink>
    | l.$Typed<SystemMessageDataDisableJoinLink>
    | l.Unknown$TypedObject
  sentAt: l.DatetimeString
}

export type { SystemMessageView }

const systemMessageView = /*#__PURE__*/ l.typedObject<SystemMessageView>(
  $nsid,
  'systemMessageView',
  /*#__PURE__*/ l.object({
    id: /*#__PURE__*/ l.string(),
    rev: /*#__PURE__*/ l.string(),
    data: /*#__PURE__*/ l.typedUnion(
      [
        /*#__PURE__*/ l.typedRef<SystemMessageDataAddMember>(
          (() => systemMessageDataAddMember) as any,
        ),
        /*#__PURE__*/ l.typedRef<SystemMessageDataRemoveMember>(
          (() => systemMessageDataRemoveMember) as any,
        ),
        /*#__PURE__*/ l.typedRef<SystemMessageDataMemberJoin>(
          (() => systemMessageDataMemberJoin) as any,
        ),
        /*#__PURE__*/ l.typedRef<SystemMessageDataMemberLeave>(
          (() => systemMessageDataMemberLeave) as any,
        ),
        /*#__PURE__*/ l.typedRef<SystemMessageDataLockConvo>(
          (() => systemMessageDataLockConvo) as any,
        ),
        /*#__PURE__*/ l.typedRef<SystemMessageDataUnlockConvo>(
          (() => systemMessageDataUnlockConvo) as any,
        ),
        /*#__PURE__*/ l.typedRef<SystemMessageDataLockConvoPermanently>(
          (() => systemMessageDataLockConvoPermanently) as any,
        ),
        /*#__PURE__*/ l.typedRef<SystemMessageDataEditGroup>(
          (() => systemMessageDataEditGroup) as any,
        ),
        /*#__PURE__*/ l.typedRef<SystemMessageDataCreateJoinLink>(
          (() => systemMessageDataCreateJoinLink) as any,
        ),
        /*#__PURE__*/ l.typedRef<SystemMessageDataEditJoinLink>(
          (() => systemMessageDataEditJoinLink) as any,
        ),
        /*#__PURE__*/ l.typedRef<SystemMessageDataEnableJoinLink>(
          (() => systemMessageDataEnableJoinLink) as any,
        ),
        /*#__PURE__*/ l.typedRef<SystemMessageDataDisableJoinLink>(
          (() => systemMessageDataDisableJoinLink) as any,
        ),
      ],
      false,
    ),
    sentAt: /*#__PURE__*/ l.string({ format: 'datetime' }),
  }),
)

export { systemMessageView }

type DeletedMessageView = {
  $type?: 'chat.bsky.convo.defs#deletedMessageView'
  id: string
  rev: string
  sender: MessageViewSender
  sentAt: l.DatetimeString
}

export type { DeletedMessageView }

const deletedMessageView = /*#__PURE__*/ l.typedObject<DeletedMessageView>(
  $nsid,
  'deletedMessageView',
  /*#__PURE__*/ l.object({
    id: /*#__PURE__*/ l.string(),
    rev: /*#__PURE__*/ l.string(),
    sender: /*#__PURE__*/ l.ref<MessageViewSender>(
      (() => messageViewSender) as any,
    ),
    sentAt: /*#__PURE__*/ l.string({ format: 'datetime' }),
  }),
)

export { deletedMessageView }

/** Event indicating a join link was disabled for a group convo. */
type LogDisableJoinLink = {
  $type?: 'chat.bsky.convo.defs#logDisableJoinLink'
  rev: string
  convoId: string

  /**
   * A system message with data of type #systemMessageDataDisableJoinLink
   */
  message: SystemMessageView
}

export type { LogDisableJoinLink }

/** Event indicating a join link was disabled for a group convo. */
const logDisableJoinLink = /*#__PURE__*/ l.typedObject<LogDisableJoinLink>(
  $nsid,
  'logDisableJoinLink',
  /*#__PURE__*/ l.object({
    rev: /*#__PURE__*/ l.string(),
    convoId: /*#__PURE__*/ l.string(),
    message: /*#__PURE__*/ l.ref<SystemMessageView>(
      (() => systemMessageView) as any,
    ),
  }),
)

export { logDisableJoinLink }

type ReactionViewSender = {
  $type?: 'chat.bsky.convo.defs#reactionViewSender'
  did: l.DidString
}

export type { ReactionViewSender }

const reactionViewSender = /*#__PURE__*/ l.typedObject<ReactionViewSender>(
  $nsid,
  'reactionViewSender',
  /*#__PURE__*/ l.object({ did: /*#__PURE__*/ l.string({ format: 'did' }) }),
)

export { reactionViewSender }

/** Event indicating the group owner marked join requests as read. Only the owner gets this. */
type LogReadJoinRequests = {
  $type?: 'chat.bsky.convo.defs#logReadJoinRequests'
  rev: string
  convoId: string
}

export type { LogReadJoinRequests }

/** Event indicating the group owner marked join requests as read. Only the owner gets this. */
const logReadJoinRequests = /*#__PURE__*/ l.typedObject<LogReadJoinRequests>(
  $nsid,
  'logReadJoinRequests',
  /*#__PURE__*/ l.object({
    rev: /*#__PURE__*/ l.string(),
    convoId: /*#__PURE__*/ l.string(),
  }),
)

export { logReadJoinRequests }

/** Event indicating a join request was rejected by the viewer. Only the owner gets this. */
type LogRejectJoinRequest = {
  $type?: 'chat.bsky.convo.defs#logRejectJoinRequest'
  rev: string

  /**
   * Prospective member who requested to join.
   */
  member: ActorDefs.ProfileViewBasic
  convoId: string
}

export type { LogRejectJoinRequest }

/** Event indicating a join request was rejected by the viewer. Only the owner gets this. */
const logRejectJoinRequest = /*#__PURE__*/ l.typedObject<LogRejectJoinRequest>(
  $nsid,
  'logRejectJoinRequest',
  /*#__PURE__*/ l.object({
    rev: /*#__PURE__*/ l.string(),
    member: /*#__PURE__*/ l.ref<ActorDefs.ProfileViewBasic>(
      (() => ActorDefs.profileViewBasic) as any,
    ),
    convoId: /*#__PURE__*/ l.string(),
  }),
)

export { logRejectJoinRequest }

/** Event indicating a join request was approved by the viewer. Only the owner gets this. The approved member gets a logBeginConvo. */
type LogApproveJoinRequest = {
  $type?: 'chat.bsky.convo.defs#logApproveJoinRequest'
  rev: string

  /**
   * Prospective member who requested to join.
   */
  member: ActorDefs.ProfileViewBasic
  convoId: string
}

export type { LogApproveJoinRequest }

/** Event indicating a join request was approved by the viewer. Only the owner gets this. The approved member gets a logBeginConvo. */
const logApproveJoinRequest =
  /*#__PURE__*/ l.typedObject<LogApproveJoinRequest>(
    $nsid,
    'logApproveJoinRequest',
    /*#__PURE__*/ l.object({
      rev: /*#__PURE__*/ l.string(),
      member: /*#__PURE__*/ l.ref<ActorDefs.ProfileViewBasic>(
        (() => ActorDefs.profileViewBasic) as any,
      ),
      convoId: /*#__PURE__*/ l.string(),
    }),
  )

export { logApproveJoinRequest }

/** Event indicating a join request was made to a group the viewer owns. Only the owner gets this. */
type LogIncomingJoinRequest = {
  $type?: 'chat.bsky.convo.defs#logIncomingJoinRequest'
  rev: string

  /**
   * Prospective member who requested to join.
   */
  member: ActorDefs.ProfileViewBasic
  convoId: string
}

export type { LogIncomingJoinRequest }

/** Event indicating a join request was made to a group the viewer owns. Only the owner gets this. */
const logIncomingJoinRequest =
  /*#__PURE__*/ l.typedObject<LogIncomingJoinRequest>(
    $nsid,
    'logIncomingJoinRequest',
    /*#__PURE__*/ l.object({
      rev: /*#__PURE__*/ l.string(),
      member: /*#__PURE__*/ l.ref<ActorDefs.ProfileViewBasic>(
        (() => ActorDefs.profileViewBasic) as any,
      ),
      convoId: /*#__PURE__*/ l.string(),
    }),
  )

export { logIncomingJoinRequest }

/** Event indicating a join request was made by the requester. Only requester actor gets this. */
type LogOutgoingJoinRequest = {
  $type?: 'chat.bsky.convo.defs#logOutgoingJoinRequest'
  rev: string
  convoId: string
}

export type { LogOutgoingJoinRequest }

/** Event indicating a join request was made by the requester. Only requester actor gets this. */
const logOutgoingJoinRequest =
  /*#__PURE__*/ l.typedObject<LogOutgoingJoinRequest>(
    $nsid,
    'logOutgoingJoinRequest',
    /*#__PURE__*/ l.object({
      rev: /*#__PURE__*/ l.string(),
      convoId: /*#__PURE__*/ l.string(),
    }),
  )

export { logOutgoingJoinRequest }

type MessageAndReactionView = {
  $type?: 'chat.bsky.convo.defs#messageAndReactionView'
  message: MessageView
  reaction: ReactionView
}

export type { MessageAndReactionView }

const messageAndReactionView =
  /*#__PURE__*/ l.typedObject<MessageAndReactionView>(
    $nsid,
    'messageAndReactionView',
    /*#__PURE__*/ l.object({
      message: /*#__PURE__*/ l.ref<MessageView>((() => messageView) as any),
      reaction: /*#__PURE__*/ l.ref<ReactionView>((() => reactionView) as any),
    }),
  )

export { messageAndReactionView }

/** Event indicating a group convo was locked permanently. */
type LogLockConvoPermanently = {
  $type?: 'chat.bsky.convo.defs#logLockConvoPermanently'
  rev: string
  convoId: string

  /**
   * A system message with data of type #systemMessageDataLockConvoPermanently
   */
  message: SystemMessageView

  /**
   * Profiles referred in the system message.
   */
  relatedProfiles: ActorDefs.ProfileViewBasic[]
}

export type { LogLockConvoPermanently }

/** Event indicating a group convo was locked permanently. */
const logLockConvoPermanently =
  /*#__PURE__*/ l.typedObject<LogLockConvoPermanently>(
    $nsid,
    'logLockConvoPermanently',
    /*#__PURE__*/ l.object({
      rev: /*#__PURE__*/ l.string(),
      convoId: /*#__PURE__*/ l.string(),
      message: /*#__PURE__*/ l.ref<SystemMessageView>(
        (() => systemMessageView) as any,
      ),
      relatedProfiles: /*#__PURE__*/ l.array(
        /*#__PURE__*/ l.ref<ActorDefs.ProfileViewBasic>(
          (() => ActorDefs.profileViewBasic) as any,
        ),
      ),
    }),
  )

export { logLockConvoPermanently }

type SystemMessageReferredUser = {
  $type?: 'chat.bsky.convo.defs#systemMessageReferredUser'
  did: l.DidString
}

export type { SystemMessageReferredUser }

const systemMessageReferredUser =
  /*#__PURE__*/ l.typedObject<SystemMessageReferredUser>(
    $nsid,
    'systemMessageReferredUser',
    /*#__PURE__*/ l.object({ did: /*#__PURE__*/ l.string({ format: 'did' }) }),
  )

export { systemMessageReferredUser }

/** System message indicating a user was added to the group convo. */
type SystemMessageDataAddMember = {
  $type?: 'chat.bsky.convo.defs#systemMessageDataAddMember'

  /**
   * Role the user was added to the group with. The role from 'member' will reflect the current data, not historical.
   */
  role: ActorDefs.MemberRole

  /**
   * Current view of the member who was added.
   */
  member: SystemMessageReferredUser
  addedBy: SystemMessageReferredUser
}

export type { SystemMessageDataAddMember }

/** System message indicating a user was added to the group convo. */
const systemMessageDataAddMember =
  /*#__PURE__*/ l.typedObject<SystemMessageDataAddMember>(
    $nsid,
    'systemMessageDataAddMember',
    /*#__PURE__*/ l.object({
      role: /*#__PURE__*/ l.ref<ActorDefs.MemberRole>(
        (() => ActorDefs.memberRole) as any,
      ),
      member: /*#__PURE__*/ l.ref<SystemMessageReferredUser>(
        (() => systemMessageReferredUser) as any,
      ),
      addedBy: /*#__PURE__*/ l.ref<SystemMessageReferredUser>(
        (() => systemMessageReferredUser) as any,
      ),
    }),
  )

export { systemMessageDataAddMember }

/** System message indicating the group info was edited. */
type SystemMessageDataEditGroup = {
  $type?: 'chat.bsky.convo.defs#systemMessageDataEditGroup'

  /**
   * Group name that replaced the old.
   */
  newName?: string

  /**
   * Group name that was replaced.
   */
  oldName?: string
}

export type { SystemMessageDataEditGroup }

/** System message indicating the group info was edited. */
const systemMessageDataEditGroup =
  /*#__PURE__*/ l.typedObject<SystemMessageDataEditGroup>(
    $nsid,
    'systemMessageDataEditGroup',
    /*#__PURE__*/ l.object({
      newName: /*#__PURE__*/ l.optional(/*#__PURE__*/ l.string()),
      oldName: /*#__PURE__*/ l.optional(/*#__PURE__*/ l.string()),
    }),
  )

export { systemMessageDataEditGroup }

/** System message indicating the group convo was locked. */
type SystemMessageDataLockConvo = {
  $type?: 'chat.bsky.convo.defs#systemMessageDataLockConvo'

  /**
   * Current view of the member who locked the group.
   */
  lockedBy: SystemMessageReferredUser
}

export type { SystemMessageDataLockConvo }

/** System message indicating the group convo was locked. */
const systemMessageDataLockConvo =
  /*#__PURE__*/ l.typedObject<SystemMessageDataLockConvo>(
    $nsid,
    'systemMessageDataLockConvo',
    /*#__PURE__*/ l.object({
      lockedBy: /*#__PURE__*/ l.ref<SystemMessageReferredUser>(
        (() => systemMessageReferredUser) as any,
      ),
    }),
  )

export { systemMessageDataLockConvo }

/** System message indicating a user joined the group convo via join link. */
type SystemMessageDataMemberJoin = {
  $type?: 'chat.bsky.convo.defs#systemMessageDataMemberJoin'

  /**
   * Role the user was added to the group with. The role from 'member' will reflect the current data, not historical.
   */
  role: ActorDefs.MemberRole

  /**
   * Current view of the member who joined.
   */
  member: SystemMessageReferredUser

  /**
   * If join link was configured to require approval, this will be set to who approved the request. Undefined if approval was not required.
   */
  approvedBy?: SystemMessageReferredUser
}

export type { SystemMessageDataMemberJoin }

/** System message indicating a user joined the group convo via join link. */
const systemMessageDataMemberJoin =
  /*#__PURE__*/ l.typedObject<SystemMessageDataMemberJoin>(
    $nsid,
    'systemMessageDataMemberJoin',
    /*#__PURE__*/ l.object({
      role: /*#__PURE__*/ l.ref<ActorDefs.MemberRole>(
        (() => ActorDefs.memberRole) as any,
      ),
      member: /*#__PURE__*/ l.ref<SystemMessageReferredUser>(
        (() => systemMessageReferredUser) as any,
      ),
      approvedBy: /*#__PURE__*/ l.optional(
        /*#__PURE__*/ l.ref<SystemMessageReferredUser>(
          (() => systemMessageReferredUser) as any,
        ),
      ),
    }),
  )

export { systemMessageDataMemberJoin }

/** System message indicating a user voluntarily left the group convo. */
type SystemMessageDataMemberLeave = {
  $type?: 'chat.bsky.convo.defs#systemMessageDataMemberLeave'

  /**
   * Current view of the member who left the group.
   */
  member: SystemMessageReferredUser
}

export type { SystemMessageDataMemberLeave }

/** System message indicating a user voluntarily left the group convo. */
const systemMessageDataMemberLeave =
  /*#__PURE__*/ l.typedObject<SystemMessageDataMemberLeave>(
    $nsid,
    'systemMessageDataMemberLeave',
    /*#__PURE__*/ l.object({
      member: /*#__PURE__*/ l.ref<SystemMessageReferredUser>(
        (() => systemMessageReferredUser) as any,
      ),
    }),
  )

export { systemMessageDataMemberLeave }

/** System message indicating the group convo was unlocked. */
type SystemMessageDataUnlockConvo = {
  $type?: 'chat.bsky.convo.defs#systemMessageDataUnlockConvo'

  /**
   * Current view of the member who unlocked the group.
   */
  unlockedBy: SystemMessageReferredUser
}

export type { SystemMessageDataUnlockConvo }

/** System message indicating the group convo was unlocked. */
const systemMessageDataUnlockConvo =
  /*#__PURE__*/ l.typedObject<SystemMessageDataUnlockConvo>(
    $nsid,
    'systemMessageDataUnlockConvo',
    /*#__PURE__*/ l.object({
      unlockedBy: /*#__PURE__*/ l.ref<SystemMessageReferredUser>(
        (() => systemMessageReferredUser) as any,
      ),
    }),
  )

export { systemMessageDataUnlockConvo }

/** System message indicating the group join link was edited. */
type SystemMessageDataEditJoinLink = {
  $type?: 'chat.bsky.convo.defs#systemMessageDataEditJoinLink'
}

export type { SystemMessageDataEditJoinLink }

/** System message indicating the group join link was edited. */
const systemMessageDataEditJoinLink =
  /*#__PURE__*/ l.typedObject<SystemMessageDataEditJoinLink>(
    $nsid,
    'systemMessageDataEditJoinLink',
    /*#__PURE__*/ l.object({}),
  )

export { systemMessageDataEditJoinLink }

/** System message indicating a user was removed from the group convo. */
type SystemMessageDataRemoveMember = {
  $type?: 'chat.bsky.convo.defs#systemMessageDataRemoveMember'

  /**
   * Current view of the member who was removed.
   */
  member: SystemMessageReferredUser
  removedBy: SystemMessageReferredUser
}

export type { SystemMessageDataRemoveMember }

/** System message indicating a user was removed from the group convo. */
const systemMessageDataRemoveMember =
  /*#__PURE__*/ l.typedObject<SystemMessageDataRemoveMember>(
    $nsid,
    'systemMessageDataRemoveMember',
    /*#__PURE__*/ l.object({
      member: /*#__PURE__*/ l.ref<SystemMessageReferredUser>(
        (() => systemMessageReferredUser) as any,
      ),
      removedBy: /*#__PURE__*/ l.ref<SystemMessageReferredUser>(
        (() => systemMessageReferredUser) as any,
      ),
    }),
  )

export { systemMessageDataRemoveMember }

/** Event indicating a prospective member withdrew their join request. Only the owner gets this. */
type LogWithdrawIncomingJoinRequest = {
  $type?: 'chat.bsky.convo.defs#logWithdrawIncomingJoinRequest'
  rev: string

  /**
   * Prospective member who withdrew their join request.
   */
  member: ActorDefs.ProfileViewBasic
  convoId: string
}

export type { LogWithdrawIncomingJoinRequest }

/** Event indicating a prospective member withdrew their join request. Only the owner gets this. */
const logWithdrawIncomingJoinRequest =
  /*#__PURE__*/ l.typedObject<LogWithdrawIncomingJoinRequest>(
    $nsid,
    'logWithdrawIncomingJoinRequest',
    /*#__PURE__*/ l.object({
      rev: /*#__PURE__*/ l.string(),
      member: /*#__PURE__*/ l.ref<ActorDefs.ProfileViewBasic>(
        (() => ActorDefs.profileViewBasic) as any,
      ),
      convoId: /*#__PURE__*/ l.string(),
    }),
  )

export { logWithdrawIncomingJoinRequest }

/** Event indicating the viewer withdrew their own join request. Only requester actor gets this. */
type LogWithdrawOutgoingJoinRequest = {
  $type?: 'chat.bsky.convo.defs#logWithdrawOutgoingJoinRequest'
  rev: string
  convoId: string
}

export type { LogWithdrawOutgoingJoinRequest }

/** Event indicating the viewer withdrew their own join request. Only requester actor gets this. */
const logWithdrawOutgoingJoinRequest =
  /*#__PURE__*/ l.typedObject<LogWithdrawOutgoingJoinRequest>(
    $nsid,
    'logWithdrawOutgoingJoinRequest',
    /*#__PURE__*/ l.object({
      rev: /*#__PURE__*/ l.string(),
      convoId: /*#__PURE__*/ l.string(),
    }),
  )

export { logWithdrawOutgoingJoinRequest }

/** System message indicating the group join link was created. */
type SystemMessageDataCreateJoinLink = {
  $type?: 'chat.bsky.convo.defs#systemMessageDataCreateJoinLink'
}

export type { SystemMessageDataCreateJoinLink }

/** System message indicating the group join link was created. */
const systemMessageDataCreateJoinLink =
  /*#__PURE__*/ l.typedObject<SystemMessageDataCreateJoinLink>(
    $nsid,
    'systemMessageDataCreateJoinLink',
    /*#__PURE__*/ l.object({}),
  )

export { systemMessageDataCreateJoinLink }

/** System message indicating the group join link was enabled. */
type SystemMessageDataEnableJoinLink = {
  $type?: 'chat.bsky.convo.defs#systemMessageDataEnableJoinLink'
}

export type { SystemMessageDataEnableJoinLink }

/** System message indicating the group join link was enabled. */
const systemMessageDataEnableJoinLink =
  /*#__PURE__*/ l.typedObject<SystemMessageDataEnableJoinLink>(
    $nsid,
    'systemMessageDataEnableJoinLink',
    /*#__PURE__*/ l.object({}),
  )

export { systemMessageDataEnableJoinLink }

/** Placeholder embedded in place of a reply's parent message when that parent was sent before the viewer joined the group convo. The viewer has no access to that history, so no message data is carried. */
type MessageBeforeUserJoinedGroupView = {
  $type?: 'chat.bsky.convo.defs#messageBeforeUserJoinedGroupView'
}

export type { MessageBeforeUserJoinedGroupView }

/** Placeholder embedded in place of a reply's parent message when that parent was sent before the viewer joined the group convo. The viewer has no access to that history, so no message data is carried. */
const messageBeforeUserJoinedGroupView =
  /*#__PURE__*/ l.typedObject<MessageBeforeUserJoinedGroupView>(
    $nsid,
    'messageBeforeUserJoinedGroupView',
    /*#__PURE__*/ l.object({}),
  )

export { messageBeforeUserJoinedGroupView }

/** System message indicating the group join link was disabled. */
type SystemMessageDataDisableJoinLink = {
  $type?: 'chat.bsky.convo.defs#systemMessageDataDisableJoinLink'
}

export type { SystemMessageDataDisableJoinLink }

/** System message indicating the group join link was disabled. */
const systemMessageDataDisableJoinLink =
  /*#__PURE__*/ l.typedObject<SystemMessageDataDisableJoinLink>(
    $nsid,
    'systemMessageDataDisableJoinLink',
    /*#__PURE__*/ l.object({}),
  )

export { systemMessageDataDisableJoinLink }

/** System message indicating the group convo was locked permanently. */
type SystemMessageDataLockConvoPermanently = {
  $type?: 'chat.bsky.convo.defs#systemMessageDataLockConvoPermanently'

  /**
   * Current view of the member who locked the group.
   */
  lockedBy: SystemMessageReferredUser
}

export type { SystemMessageDataLockConvoPermanently }

/** System message indicating the group convo was locked permanently. */
const systemMessageDataLockConvoPermanently =
  /*#__PURE__*/ l.typedObject<SystemMessageDataLockConvoPermanently>(
    $nsid,
    'systemMessageDataLockConvoPermanently',
    /*#__PURE__*/ l.object({
      lockedBy: /*#__PURE__*/ l.ref<SystemMessageReferredUser>(
        (() => systemMessageReferredUser) as any,
      ),
    }),
  )

export { systemMessageDataLockConvoPermanently }
